import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography, Box, Container, Stack } from '@mui/material';

const Home = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        pt: { xs: 6, sm: 8, md: 10 },
        mb: 12,
        px: { xs: 3, sm: 4 },
      }}
    >
      <Typography
        variant="h3"
        align="center"
        sx={{
          fontWeight: 800,
          mb: 2,
          fontSize: {
            xs: '2.15rem',
            sm: '2.75rem',
            md: '3.4rem',
          },
          lineHeight: 1.08,
          letterSpacing: '-0.045em',
        }}
      >
        Welcome to HaggleFreight!
      </Typography>

      <Box
        sx={{
          width: 64,
          height: 4,
          bgcolor: 'primary.main',
          borderRadius: 10,
          mx: 'auto',
          mb: 4,
        }}
      />

      <Typography
        variant="body1"
        align="center"
        color="text.secondary"
        sx={{
          mb: 1.75,
          mx: 'auto',
          maxWidth: 560,
          fontSize: {
            xs: '1rem',
            sm: '1.12rem',
          },
          lineHeight: 1.6,
        }}
      >
        Transportation and supply chain marketplace connecting businesses,
        shippers, couriers, carriers, and logistics providers. Compare options,
        negotiate rates directly, and move loads efficiently.
      </Typography>

      <Typography
        variant="body2"
        align="center"
        color="text.secondary"
        sx={{
          mb: { xs: 5, md: 5.5 },
          mx: 'auto',
          maxWidth: 430,
          fontSize: {
            xs: '0.96rem',
            sm: '1rem',
          },
          lineHeight: 1.55,
          opacity: 0.85,
        }}
      >
        Load posting, carrier matching, and transportation management tools.
      </Typography>

      <Box textAlign="center" mb={7}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{
            fontWeight: 800,
            mb: 2.25,
          }}
        >
          Get started as:
        </Typography>

        <Stack
          direction="column"
          spacing={2}
          justifyContent="center"
          alignItems="center"
          sx={{
            mx: 'auto',
            maxWidth: 340,
          }}
        >
          <Button
            component={Link}
            to="/customer/sign-in"
            color="primary"
            variant="contained"
            size="large"
            fullWidth
            sx={{
              minHeight: 48,
              fontWeight: 800,
              textTransform: 'uppercase',
              borderRadius: 2.5,
              fontSize: '0.95rem',
              letterSpacing: '0.03em',
              boxShadow: 2,
            }}
          >
            CUSTOMER
          </Button>

          <Button
            component={Link}
            to="/courier/sign-in"
            color="primary"
            variant="contained"
            size="large"
            fullWidth
            sx={{
              minHeight: 48,
              fontWeight: 800,
              textTransform: 'uppercase',
              borderRadius: 2.5,
              fontSize: '0.95rem',
              letterSpacing: '0.03em',
              boxShadow: 2,
            }}
          >
            DRIVER / CARRIER
          </Button>
        </Stack>
      </Box>
    </Container>
  );
};

export default Home;